import React from 'react';

import { Error500Box } from 'components/error-handle/errors/error-500-box';
import { getNewRelicAgent } from 'newRelicAgent';

export const Error500Page = ({ error }) => {
  if (error) {
    getNewRelicAgent().noticeError(error);
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <Error500Box />
        </div>
      </div>
    </div>
  );
};
